import { t } from "@lingui/macro";
import * as React from "react";
import { G, Path, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const BoatingIcon = (props: IconProps) => {
  const clipPathId = React.useId();

  return (
    <Icon
      fill="none"
      viewBox="0 0 16 16"
      color="#001A19"
      title={t`Boating`}
      {...props}
    >
      <G clipPath={`url(#${clipPathId})`}>
        <Path
          fill="currentColor"
          d="M9.54 10.385V.475l-1.194.77a15.107 15.107 0 0 0-6.29 8.947l-.046.193H0l1.07 3.195a2.308 2.308 0 0 0-.77-.115v1.54c.431 0 .616.17.994.546a2.765 2.765 0 0 0 2.086.994 2.742 2.742 0 0 0 2.08-.994c.376-.377.561-.546.992-.546.432 0 .616.17 1.001.546a2.68 2.68 0 0 0 4.166 0c.377-.377.562-.546 1-.546.44 0 .617.17.994.546a2.765 2.765 0 0 0 2.087.994v-1.54c-.431 0-.616-.17-.994-.547l-.046-.046L16 10.385H9.54Zm-1.54 0H3.596A13.575 13.575 0 0 1 8 3.455v6.93Z"
        />
      </G>
      <Defs>
        <ClipPath id={clipPathId}>
          <Path fill="#fff" d="M0 0h16v16H0z" />
        </ClipPath>
      </Defs>
    </Icon>
  );
};
